import React from 'react';

interface VendedorDropdownProps {
    value: string;
    onChange: (value: string) => void;
    vendedores: string[];
    disabled?: boolean;
    className?: string;
}

export const VendedorDropdown: React.FC<VendedorDropdownProps> = ({
    value,
    onChange,
    vendedores,
    disabled = false,
    className = ''
}) => {
    return (
        <select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            disabled={disabled}
            className={`w-full px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-dexco-green-primary focus:border-transparent ${disabled ? 'bg-gray-50 text-gray-500' : ''} ${className}`}
        >
            <option value="">Selecione um vendedor</option>
            {vendedores.map(vendedor => (
                <option key={vendedor} value={vendedor}>
                    {vendedor}
                </option>
            ))}
        </select>
    );
};

interface ClienteDropdownProps {
    value: string;
    onChange: (value: string) => void;
    clientes: string[]; // Now expects unique client names
    disabled?: boolean;
    className?: string;
}

export const ClienteDropdown: React.FC<ClienteDropdownProps> = ({
    value,
    onChange,
    clientes,
    disabled = false,
    className = ''
}) => {
    return (
        <select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            disabled={disabled}
            className={`w-full px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-dexco-green-primary focus:border-transparent ${disabled ? 'bg-gray-50 text-gray-500' : ''} ${className}`}
        >
            <option value="">Selecione um cliente</option>
            {clientes.map(cliente => (
                <option key={cliente} value={cliente}>
                    {cliente}
                </option>
            ))}
        </select>
    );
};

interface CodigoDropdownProps {
    value: string;
    onChange: (value: string) => void;
    codigos: string[];
    disabled?: boolean;
    className?: string;
}

export const CodigoDropdown: React.FC<CodigoDropdownProps> = ({
    value,
    onChange,
    codigos,
    disabled = false,
    className = ''
}) => {
    return (
        <select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            disabled={disabled}
            className={`w-full px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-dexco-green-primary focus:border-transparent ${disabled ? 'bg-gray-50 text-gray-500' : ''} ${className}`}
        >
            <option value="">Selecione um código</option>
            {codigos.map(codigo => (
                <option key={codigo} value={codigo}>
                    {codigo}
                </option>
            ))}
        </select>
    );
};

interface ReadOnlyFieldProps {
    label: string;
    value: string | number;
    isInfinito?: boolean;
    tooltipText?: string;
    className?: string;
}

export const ReadOnlyField: React.FC<ReadOnlyFieldProps> = ({
    label,
    value,
    isInfinito = false,
    tooltipText,
    className = ''
}) => {
    const displayValue = isInfinito ? 'Sem limite' : value.toString();

    return (
        <div className={className}>
            <label className="block text-xs font-medium text-gray-700 mb-1">{label}</label>
            <div
                className="px-3 py-2 text-sm bg-gray-50 border border-gray-200 rounded text-gray-600"
                title={tooltipText || displayValue}
            >
                {displayValue}
            </div>
        </div>
    );
};

interface CodigoClienteFieldProps {
    codigo: string;
    className?: string;
}

export const CodigoClienteField: React.FC<CodigoClienteFieldProps> = ({
    codigo,
    className = ''
}) => {
    return (
        <div className={className}>
            <div className="px-3 py-2 text-sm bg-gray-50 border border-gray-200 rounded text-gray-600 font-mono">
                {codigo || '-'}
            </div>
        </div>
    );
}; 